import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#b20fc0",
      d: "M7.218 9.231a3.012 3.012 0 0 1-3.012-3.012v-2.41a.602.602 0 0 1 .602-.602h.603a.602.602 0 0 0 .426-1.028A.607.607 0 0 0 5.41 2h-.603A1.81 1.81 0 0 0 3 3.808v2.41a4.211 4.211 0 0 0 1.82 3.459 5.3 5.3 0 0 1 1.285 1.702 5.3 5.3 0 0 1 .511 2.07 4.22 4.22 0 0 0 4.218 4.218 4.22 4.22 0 0 0 4.218-4.218v-.687a2.41 2.41 0 0 0 1.789-2.637 2.41 2.41 0 0 0-2.391-2.107 2.41 2.41 0 0 0-2.391 2.107 2.41 2.41 0 0 0 1.788 2.637v.687a3.012 3.012 0 1 1-6.024 0A5.307 5.307 0 0 1 9.63 9.677a4.197 4.197 0 0 0 1.807-3.459v-2.41A1.81 1.81 0 0 0 9.628 2h-.603a.602.602 0 1 0 0 1.204h.603a.6.6 0 0 1 .426.176.603.603 0 0 1 .177.426v2.41a3.02 3.02 0 0 1-.882 2.13 3.025 3.025 0 0 1-2.13.882zm7.231 2.41a1.204 1.204 0 1 1 0-2.408 1.204 1.204 0 0 1 0 2.408z"
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "stethoscope"}) } }